<template>
  <div>
    <!-- Small Screen Menu -->
    <nav class="miniNav" aria-label="Mobile navigation">
      <button class="dropdown-elem" @click="toggleMenuDropdown">
        Menu
      </button>
      <ul v-if="menuDropdown.show" class="dropdown">
        <li v-for="(item, i) in navItems" :key="`nav-${i}`">
          <template v-if="item.path === '/'">
            <router-link :to="item.path" exact>{{ item.name }}</router-link>
          </template>
          <template v-else-if="item.path === '/project'">
            <span>{{ item.name }}</span>
            <ul class="project-list">
              <li v-for="(project, i) in projectList" :key="`fea-${i}`">
                <router-link class="dropdown-elem" :to="`/project/${project.id}`"
                             @click.prevent="fetchProject(project.id)">

                  <template v-if="project.type === 'implementation'">
                    <img :src="`/icons/${projectTypeIcon.IMPLEMENTATION}-light.svg`" alt="" aria-label="A coding project">
                  </template>
                  <template v-else-if="project.type === 'research'">
                    <img :src="`/icons/${projectTypeIcon.RESEARCH}-light.svg`" alt="" aria-label="A research project" style="height:1.35rem;">
                  </template>
                  <template v-else-if="project.type === 'design'">
                    <img :src="`/icons/${projectTypeIcon.DESIGN}-light.svg`" alt="" aria-label="A design project">
                  </template>
                  <span>{{ project.name }}</span>
                </router-link>
              </li>
            </ul>
          </template>
          <template v-else>
            <router-link :to="item.path">{{ item.name }}</router-link>
          </template>
        </li>
      </ul>
    </nav>

    <!-- Horizontal Menu -->
    <nav class="fullNav" aria-label="Navigation bar">
      <ul class="menu">
        <li v-for="(item, i) in navItems" :key="`nav-${i}`">
          <template v-if="item.path === '/'">
            <router-link :to="item.path" exact>{{ item.name }}</router-link>
          </template>
          <template v-else-if="item.path === '/project'">
            <a id="featuredControl"
              style="width: 202px;"
              href="#"
              @click.prevent="toggleProjectDropdown"
              class="dropdown-elem"
              :class="focused"
              aria-controls="featuredList"
              aria-haspopup="true"
              :aria-expanded="`${projectDropdown.show}`"
            >{{ item.name }}
              <img src="/icons/chevron-down-light.svg" alt="" :class="{ 'flip': projectDropdown.show, 'unflip': !projectDropdown.show }"></a>
            <!-- project dropdown menu -->
            <transition name="fade">
              <ul id="featuredList" class="dropdown project-list" v-show="projectDropdown.show" :class="{ whiteHeaderDropdown: showWhiteHeader}">
                <li v-for="(project, i) in projectList" :key="`prj-${i}`">
                  <router-link class="dropdown-elem" :to="`/project/${project.id}`" @click.prevent="fetchProject(project.id)">
                    <template v-if="project.type === 'implementation'">
                      <img :src="`/icons/${projectTypeIcon.IMPLEMENTATION}-light.svg`" alt="" aria-label="A coding project">
                    </template>
                    <template v-else-if="project.type === 'research'">
                      <img :src="`/icons/${projectTypeIcon.RESEARCH}-light.svg`" alt="" aria-label="A research project" style="height:1.35rem;">
                    </template>
                    <template v-else-if="project.type === 'design'">
                      <img :src="`/icons/${projectTypeIcon.DESIGN}-light.svg`" alt="" aria-label="A design project">
                    </template>
                    <span>{{ project.name }}</span>
                  </router-link>
                </li>
              </ul>
            </transition>
          </template>
          <template v-else>
            <router-link :to="item.path">{{ item.name }}</router-link>
          </template>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Navigation',
  computed: {
    ...mapState([
      'navItems',
      'menuDropdown',
      'projectDropdown',
      'projectList',
      'projectTypeIcon',
      'showWhiteHeader'
    ]),
    focused() {
      // set focus styling on "Featured Projects"
      return this.projectDropdown.show ? 'nav-focus' : '';
    }
  },
  methods: {
    fetchProject(id) {
      this.toggleMenuDropdown();
      this.toggleProjectDropdown();
      this.$store.dispatch('loadProjectById', { router: this.$router, id: id });
    },
    onKey() {
      console.log('')
    },
    toggleMenuDropdown() {
      this.$store.dispatch('updateMenuDropdown', !this.menuDropdown.show);
    },
    toggleProjectDropdown() {
      this.$store.dispatch('updateProjectDropdown', !this.projectDropdown.show);
    }
  }
};
</script>

<style scoped lang="scss">
@import '../assets/css/variables';

// TODO: fix active link in miniNav

$li-height: calc(0.8rem * 3.5);
%featured {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid $hover;
  opacity: 1;
}
%dropdown {
  background-color: white;
  border: 1px solid $hover;
  box-shadow: 1px 1px 3px #aaaaaa;
  display: block;
  list-style: none;
  margin: -1px 0 0 0;
  position: absolute;
  top: 50px;
  // right: 0; // see specific dropdown and white header dropdown
  z-index: z('dropdown-menu');

  li {
    border-bottom: 1px solid rgba(117,64,90,.07);
    @extend %font-regular-semi-bold;
    font-size: .85rem;
    text-transform: uppercase;
    a:link,
    a:hover,
    a:visited,
    a:focus {
      border: 1px solid transparent;
      color: $theme;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 0.5em;
      line-height: $li-height;
      padding: 0 1.25rem !important;
      text-align: left !important;
      width: 100%;
      img {
        @extend %color-raisin;
        margin-bottom: -1px;
        width: 1rem;
      }
    }
    &:hover, &:focus {
      a:hover, a:focus {
        //color: $theme;
        //font-weight: bold;
      }
    }
    &:last-child {
      border: 0;
    }
  }
}

/*
 * --- White Bar Styles ---
 */
.miniNav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  button {
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 1px;
    color: $theme;
    display: flex;
    font-size: 1rem;
    margin: .5rem;
    padding: .65rem 1rem;
    text-transform: uppercase;
    &:hover, &:focus {
      background-color: rgba(255, 255, 255, 0.07);
      border: 1px solid $hover;
      border-radius: 1px;
    }
  }
  ul.dropdown {
    @extend %dropdown;
    right: .5rem;
    width: 290px;
    li > span {
      // one-off
      color: rgba(0,0,0,.45);
      line-height: $li-height;
      padding-left: 1.5rem !important;
    }
    ul {
      list-style: none;
      li {
        padding-left: 1.25rem;
        border-bottom: 0 !important;
      }
    }
  }
}
.fullNav {
  display: none;
  padding: 0.25rem 0;
  ul.menu {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    list-style: none;
    margin: 0.75rem 0;
    padding: 0 2%;
    li {
      text-align: center;
      text-transform: uppercase;
      a:link,
      a:visited {
        border: 1px solid transparent;
        opacity: 0.85;
      }
      a:hover, a:focus {
        @extend %featured;
      }
      a:link,
      a:visited,
      a:hover,
      a:focus {
        @extend %font-regular-semi-bold;
        font-size: 0.9rem;
        letter-spacing: 0.75px;
        padding: 0.5rem 0.75rem;
        text-align: center;
        text-decoration: none;
      }
      &:hover, &:focus {
        // hover of the li element
        a:hover, a:focus {
          @extend %featured;
        }
      }
      a.router-link-active {
        // for vue router; place last here
        font-weight: bold;
        opacity: 1;
      }
    }
  }
  ul.dropdown {
    @extend %dropdown;
  }
  .dropdown-elem {
    img {
      @extend %color-raisin;
      margin-bottom: -3px;
      width: 0.9rem;
    }
  }
  .flip {
    transform: rotate(180deg);
  }
  .flip, .unflip {
    transition: all 0.5s;
  }
  .whiteHeaderDropdown {
    // workaround for mobile browsers where <ul> went off to the left
    right: 36px;
  }
}

// applicable to both fullNav and miniNav
.project-list {
  li:hover {
    background-color: rgba(117, 64, 90, 0.1);
  }
}

/*
 * --- Transparent Bar Styles (Home Component Only) ---
 */
header.transparent-bar {
  .miniNav {
    button {
      color: white;
      img {
        @extend %color-white;
      }
    }
    .dropdown {
      li {
        a.router-link-active {
          // for vue router; place last here
          font-weight: bold !important;
          opacity: 1;
        }
      }
    }

  }
  .fullNav {
    ul.menu {
      li {
        a:link,
        a:visited,
        a:hover,
        a:focus {
          color: white;
        }
        a.nav-focus {
          @extend %featured;
        }
        &:hover, &:focus {
          // hover of the li element
          a:hover, a:focus {
            @extend %featured;
          }
        }
      }
    }
    ul.dropdown {
      li {
        a:link,
        a:visited,
        a:hover,
        a:focus {
          color: $theme;
        }
      }
    }
    .dropdown-elem {
      img {
        @extend %color-white;
      }
    }
  }
}

@media screen and (min-width: $sm) {
  .miniNav {
    display: none;
  }
  .fullNav {
    display: block;
  }
}
</style>
